const _ = require("lodash");
const colors = require("../../util/ColorUtil").getDiagramColors();
const {
	generateImageGrid,
	generateImageBatex,
} = require("../../util/SeededRandomGridUtil");
const Common = require("./CommonHelpers");
const Math2D = require("../../util/Math2D");
const DrawingUtil = require("../../util/DrawingUtil");

const drawDiagram = function(
	ctx,
	x,
	y,
	w,
	imageBatex,
	imageCounts,
	markType,
	options = {}
) {
	const {selected = [], aspectRatio = 3, color, minScale, maxScale} = options;
	const gridInfo = generateImageGrid(imageBatex, imageCounts, aspectRatio, {
		minScale,
		maxScale,
	});
	const {imageGrid, gridSize, labelWidth} = gridInfo;
	const h = w / aspectRatio;
	const cellWidth = w / gridSize.cols;
	const cellHeight = h / gridSize.rows;
	imageGrid.forEach((cell, i) => {
		const left = x + cell.col * cellWidth;
		const top = y + cell.row * cellHeight;
		ctx.rect(left, top, cellWidth, cellHeight);
		// draw image
		cell.batex = generateImageBatex(cell.batex, {flipHorizontal: cell.flipped});
		const imageRect = [
			left + cellWidth * cell.leftOffset,
			top + cellHeight * cell.topOffset,
			cell.size * cellWidth,
			cell.size * cellWidth,
		];
		Common.drawBatexInRect(ctx, cell.batex, ...imageRect);
		const selectedIndex =
			selected &&
			_.findIndex(selected, selectedCellIndex => i === selectedCellIndex);
		const drawColor = colors[color] || colors.inputBlue;
		if (selectedIndex !== -1) {
			if (markType === "elimination") {
				const outerRect = Math2D.rectToArray(imageRect);
				DrawingUtil.drawEliminatedChoice(ctx, outerRect, {
					noPadding: true,
					xColor: drawColor,
				});
			}
			if (markType === "circle" || markType === "number") {
				// Shrink the rect of the area to be circled since
				// the circling escapes the bounds of the rect given
				const scaleFactor = -0.05;
				const shrunkRect = Math2D.padRectProportional(
					imageRect,
					scaleFactor,
					scaleFactor,
					scaleFactor,
					scaleFactor
				);
				const markLineWidth = DrawingUtil.drawChosen(ctx, shrunkRect, {
					circleColor: drawColor,
				});
				if (markType === "number") {
					// draw circle and number
					const rect = [
						left + cellWidth * cell.labelLeftOffset,
						top + cellHeight * cell.labelTopOffset,
						Math.max(labelWidth * cellWidth * 0.8, 20),
						Math.max(labelWidth * cellWidth * 0.8, 20),
					];
					const num = selectedIndex + 1;
					DrawingUtil.drawBorderedNumberCircle(ctx, rect, num, {
						borderColor: drawColor,
						lineWidth: markLineWidth,
					});
				}
			}
		}
	});
};

// Given top left coordinates and a width, calculate the height using the default or given aspect ratio.
const base = function(
	ctx,
	x,
	y,
	w,
	imageBatex,
	imageCounts,
	markType,
	options
) {
	drawDiagram(ctx, x, y, w, imageBatex, imageCounts, markType, options);
};

const pairs = function(
	ctx,
	x,
	y,
	w,
	imageBatex,
	imageCounts,
	markType,
	options
) {
	/*
		For pairs, we are given two types of images with the given quantities and pair
		them up into units. The idea is that there may or may not be odd ones out, and those
		should generally look like the others in terms of size, so we pair the odd ones out
		with "invisible" partners so the size calculations work out.
	*/
	const baseBatex = imageBatex[0] + imageBatex[1];
	const soloBatex =
		imageCounts[1] > imageCounts[0]
			? `\\phantom{${imageBatex[0]}}` + imageBatex[1]
			: imageBatex[0] + `\\phantom{${imageBatex[1]}}`;

	const processedImageBatex = [baseBatex, soloBatex];
	const totalImageQty = Math.max(imageCounts[0], imageCounts[1]);
	const qtyDiff = Math.abs(imageCounts[1] - imageCounts[0]);
	const processedImageCounts = [totalImageQty - qtyDiff, qtyDiff];

	drawDiagram(
		ctx,
		x,
		y,
		w,
		processedImageBatex,
		processedImageCounts,
		markType,
		options
	);
};

module.exports = {
	base,
	pairs,
};
